import React, { useEffect } from 'react'
import '../styles/Button.css'
import { useState } from 'react';

function Button(props) {

    var Type = props.Type;
    var theTheme = props.Theme;
    const [ButtonType, setButtonType] = useState('Button Inaktiv');
    const [ButtonIcon, setButtonIcon] = useState('Icon Inaktiv');
       
    useEffect(() => {
        if(Type == 'Same'){setButtonType('Button SameDefault'); setButtonIcon('Icon Same')}
                          
        if(Type == 'Different'){setButtonType('Button DifferentDefault'); setButtonIcon('Icon Different')}
        
        if(Type == 'Inaktiv'){ setButtonType('Button InaktivDefault'); setButtonIcon('Icon Inaktiv') }
      })

  return (
    <div className='ButtonFrame'>
        <div className={ButtonType}>
            <div className={ButtonIcon}></div>
        </div>
    </div>
  )
}

export default Button